const removeEmptyStrings = (array: string[]): string[] => {
  return array.filter((item) => item.trim() !== '');
};

const arrayUtil = {
  removeEmptyStrings,
};

export default arrayUtil;
